// 
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../edeeshop/jquery.magnify';

window.activeZoom = window.activeZoom || null;

export default class EshopImageMagnify extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
		this.magnifyActivate = this.magnifyActivate.bind(this);
		this.magnifyDeactivate = this.magnifyDeactivate.bind(this);
		this.handleEscape = this.handleEscape.bind(this);
		this.setVisibility = this.setVisibility.bind(this);
	}
	didMount() {
		const {
			opener,
		} = this.props;

		this.waitOnLoad = true;
		this.on('click', this.handleClick);
		document.addEventListener('click', this.handleOutsideClick);
		window.addEventListener('orientationchange', this.setVisibility);
		window.addEventListener('resize', this.setVisibility);
		document.addEventListener('keyup', this.handleEscape);

		this.setVisibility();

		$(document).on('EDEESHOP_PHOTOGALLERY_PHOTO_CHANGE', (e) => {
			this.magnifyDeactivate(e, window.activeZoom);
		});
	}
  willUnMount() {
	  document.removeEventListener('click', this.handleOutsideClick);
	  window.removeEventListener('orientationchange', this.setVisibility);
	  window.removeEventListener('resize', this.setVisibility);
	  document.removeEventListener('keyup', this.handleEscape);
    window.activeZoom = null;
    $('html').removeClass('magnify-active');
  }
	handleClick(e) {
		if (window.activeZoom instanceof $) {
			if (window.activeZoom.attr('id') != $(e.target).attr('id')) {
				this.magnifyDeactivate(e, window.activeZoom);
				this.magnifyActivate(e);
			}
			else {
				this.magnifyDeactivate(e, $(e.target));
			}
		}
		else {
			this.magnifyActivate(e);
		}
	}
	handleOutsideClick(e) {
    if ((window.activeZoom instanceof $) && (window.activeZoom[0].id == this.id) && (e.target.id != this.id)) {
      this.magnifyDeactivate(e, window.activeZoom);
    }
  }
	magnifyActivate(e) {
		const {
			magnifyTarget,
		} = this.props;
		const $a = $(e.target);

		$a.data('magnifyInstance', $(magnifyTarget).magnify());
		$a.removeClass('zoom-in').addClass('zoom-out');
		window.activeZoom = $a;
    $('html').addClass('magnify-active');
	}
	magnifyDeactivate(e, $target) {
		if (window.activeZoom) {
			const instance = window.activeZoom.data('magnifyInstance');
			if (instance) {
				instance.destroy();
			}
    	$target.removeClass('zoom-out').addClass('zoom-in');
			window.activeZoom = null;
      $('html').removeClass('magnify-active');
		}
	}
	// deactivate on escape key
	handleEscape(e) {
		const $a = window.activeZoom;
		// 27 = escape
		if ($a instanceof $ && e.which == 27) {
			this.magnifyDeactivate(e, $a);
		}
	};

	setVisibility() {
		const {
			magnifyTarget,
			zoomWidth,
			zoomHeight,
		} = this.props;

		const self = this;

		if ((zoomWidth > 0) && (zoomHeight > 0)) {
			if (self.waitOnLoad) {
				self.element.style.display = 'none';

				$(magnifyTarget).on('load', () => {
					self.waitOnLoad = false;
					self.setVisibilityHandler(self.element, magnifyTarget, zoomWidth, zoomHeight);
				});
			}
			else {
				self.setVisibilityHandler(self.element, magnifyTarget, zoomWidth, zoomHeight);
			}
		}
	}

	setVisibilityHandler(target, magnifyTarget, zoomWidth, zoomHeight) {
		if ((parseInt($(magnifyTarget).width()) < parseInt(zoomWidth)) || (parseInt($(magnifyTarget).height()) < parseInt(zoomHeight))) {
			target.style.display = 'block';
		}
		else {
			target.style.display = 'none';
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/EshopImageMagnify.js